import { deleteRequest } from '..';

const deleteTemplate = (ButtonPrototypeId?: string) => deleteRequest('templates', {
  ButtonPrototypeId,
});

export default deleteTemplate;
